// extracted by mini-css-extract-plugin
module.exports = {"Toggle":"Toggle_Toggle__1_-3z","open":"Toggle_open__3ELew"};